import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import SimuladorMobile from "./SimuladorMobile";
import SimuladorDesktop from "./SimuladorDesktop";

function Simulador({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <SimuladorMobile app={app} config={config} />
  ) : (
    <SimuladorDesktop app={app} config={config} />
  );
}

Simulador.defaultProps = {
  app: null,
  config: {},
};

Simulador.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Simulador;
